import { useMemo } from "react";
import settingsService from "api/settingsService";
import { ENotificationType, notification } from "utils/notification";
import styles from "../styles.module.scss";
import WizardActions from "../WizardActions";
import { useWizard } from "../WizardContext";

const Step8SafeEnvelope = () => {
  const { settings, logoKey, inline } = useWizard();

  const { data: formData } = settingsService.useGetForm(settings.WorkspaceId);
  const key = formData?.data?.[0]?.Key ?? logoKey;
  const base = import.meta.env.VITE_APP_FORM_SITE;
  const link = useMemo(() => (key ? `${base}?id=${key}` : ""), [key, base]);

  const downloadLink = () => {
    if (!link) return;
    const blob = new Blob([link], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "formularz-link.txt";
    a.click();
    URL.revokeObjectURL(url);
  };

  if (inline) {
    return (
      <div className={styles.inlinePublishActions}>
        <button
          type="button"
          className={styles.inlineDownloadBtn}
          onClick={downloadLink}
          disabled={!link}
        >
          Pobierz link
        </button>
      </div>
    );
  }

  return (
    <>
      <div className={styles.description}>
        Link — to gotowy adres URL, który możesz dołączyć do wiadomości e-mail
        lub przesyłki — kliknięcie otwiera formularz w przeglądarce.
      </div>
      <div className={styles.copyBlock}>
        <div className={styles.code}>
          <span className={styles.codeText}>{link || "—"}</span>
          <button
            type="button"
            className={styles.codeCopyBtn}
            onClick={() => {
              if (!link) return;
              navigator.clipboard.writeText(link);
              notification({ type: ENotificationType.INFO, title: "Skopiowano", text: link });
            }}
            disabled={!link}
          >
          </button>
        </div>
      </div>
      <WizardActions autonomous />
    </>
  );
};

export default Step8SafeEnvelope;
